const BillingHelper = {
    getMonthlyPriceFromSubscription: (subscription) => {
        return subscription.prices?.find((price) => price.recurring?.interval === 'month');
    },
    getFeatureValueIfNotBooleanType: (feature) =>
        typeof feature?.value !== 'boolean' ? feature?.value : '',
};

export default BillingHelper;
